/*
* Copyright (c) 2018 SGS Europe. All rights reserved.
*
* This program is the CONFIDENTIAL and PROPRIETARY property of 2018 SGS Europe.
* Any unauthorised use, reproduction, or transfer of this program is strictly
* prohibited.
*
* File Name:	Audit.js
*
* Description:	JavaScript code for Audit module.
*
* History:		05-FEB-18	P Dickson	Initial implementation.
*
*/

var g_oAudit = {};

(function () {
	"use strict";

	/**
	 * Create the Audit object.
	 */
	function Audit() {}

	/**
	 * Gets the audit trail for an annotation.
	 * @param {int} annotationId - The id of the annotation.
	 * @param {boolean} bSVGAnnotation - Is the annotation created on an SVG document.
	 */
	Audit.prototype.getAnnotationAudit = function (annotationId, bSVGAnnotation) {
		// Build up the JSON to be sent to the server.
		var oJSON = {
			AnnotationId: annotationId,
			SessionId: g_szSessionId
		};

		// Go the server and request the annotations audit trail.
		$.ajax({
			type: "POST",
			url: "internal/GreenlightAudit/getAnnotationAudit",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (response) {
				// Render the annotation audit.
				g_oAudit.renderAnnotationAudit(annotationId, response, bSVGAnnotation);
			},
			failure: function (xhr, textStatus) {
				ProcessApiError(xhr, textStatus);
			},
			error: function (xhr, textStatus) {
				ProcessApiError(xhr, textStatus);
			}
		});
	};

	/**
	 * Renders the audit trail for an annotation.
	 * @param {int} annotationId - The id of the annotation.
	 * @param {obj} annotationAudits - The list of annotation audits to be rendered.
	 */
	Audit.prototype.renderAnnotationAudit = function (annotationId, annotationAudits, bSVGAnnotation) {
		// Build up the HTML for the audit trail.
		var oAnnotationAuditHTML = "";
		
		// Create a div for closing the annotation audit.
		oAnnotationAuditHTML += "<div id='" + annotationId + "_annotationAuditClose' class='annotationAuditClose' align='right'>";

		// Add the close button.
		oAnnotationAuditHTML += "<input id='" + annotationId + "_closeAnnotationAudit' type='image' src='img/Cancel-Close_wht_24.png' title='" + g_oAudit.c_szCloseAnnotationAudit + "' class='closeannotationauditbutton tooltip'>";

		// Close the div.
		oAnnotationAuditHTML += "</div>";

		// Loop through each of the annotation audit entries.
		for (var i = 0; i < annotationAudits.length; i++) {

			// Extract the annotation audit entry.
			var oAnnotationAudit = annotationAudits[i];

			// If this is an SVG annotation.
			if (bSVGAnnotation) {

				// Get the plain text from the action description.
				oAnnotationAudit.actionDescription = g_oSVGText.getUnformattedSVGText(oAnnotationAudit.actionDescription);
			}

			// Create a div to hold the annotation audit.
			oAnnotationAuditHTML += "<div id='" + oAnnotationAudit.auditTrailId + "_annotationAudit' class='annotationAudit'>";

			// Calculate the audited time with the users time-zone offset (we display the time locally, its stored in UTC)
			var auditedDate = new Date(oAnnotationAudit.dateTimeStamp);
			var localeAuditedDate = new Date(auditedDate.getTime() - (60000 * auditedDate.getTimezoneOffset()));

			// Add the details of the annotation audit.
			oAnnotationAuditHTML += "<p style='overflow: auto; margin-top: 0px;'>" + oAnnotationAudit.actionType
				+ "<br/>" + g_oAnnotations.getDisplayName(oAnnotationAudit.userEmailAddress, oAnnotationAudit.userDisplayName)
				+ "<br/>" + formatDate(localeAuditedDate)
				+ "</p>";

			// Add the action description of the annotation audit.
			oAnnotationAuditHTML += "<p style='overflow: auto; margin-bottom: 0px;'>" + oAnnotationAudit.actionDescription + "</p>";

			// Close the div for the annotation audit.
			oAnnotationAuditHTML += "</div>";
		}

		// Add the annotation audit html to the container.
		$("#" + annotationId + "_annotationAuditContainer").html(oAnnotationAuditHTML);

		// Add the display class to the annotation audit container.
		$("#" + annotationId + "_annotationAuditContainer").addClass("annotationAuditContainer");

		// Show the content of the annotation audit container.
		$("#" + annotationId + "_annotationAuditContainer").slideDown("", "", function () { g_oAudit.scrollAnnotationAudit(annotationId); });
	};

	/**
	 * Closes the audit trail for an annotation.
	 * @param {int} annotationId - The id of the annotation.
	 */
	Audit.prototype.closeAnnotationAudit = function (annotationId, bAnimate) {

		// Determine the animation time.
		var iAnimationTime = bAnimate ? 400 : 0;

		// Close the audit for the annotation, then remove the display class for the annotation audit container.
		$("#" + annotationId + "_annotationAuditContainer").slideUp(iAnimationTime, "", function () { $("#" + annotationId + "_annotationAuditContainer").removeClass("annotationAuditContainer"); });
	};

	/**
	 * Scrolls to the audit trail for an annotation.
	 * @param {int} annotationId - The id of the annotation.
	 */
	Audit.prototype.scrollAnnotationAudit = function (annotationId) {

		// Get the position of the annotation audit container.
		var iAnnotationAuditPosition = $("#" + annotationId + "_annotationAuditContainer").position().top;

		// Remove 60px for the height of the divAnnDiv_Header and remove 20px of padding.
		iAnnotationAuditPosition -= 60;

		// Scroll the annotation audit into view.
		$("#divAnnDiv_ListItems").animate({ scrollTop: "+=" + iAnnotationAuditPosition + "px" });
	};

	/**
	 * Add the Audit object to the window.
	 */
	window.Audit = Audit;

}());